import React from "react";
import { useParams } from "react-router-dom";
import Invoices from "./Invoices";
import { CHEFS_FARM, GROWY } from "../../../../constants/CompanyConstants";

const InvoicesWrapper = () => {
  const { companyType } = useParams();

  const getCompanyConfig = (type) => {
    switch (type) {
      case "chefs-farm":
        return {
          companyFilter: CHEFS_FARM,
          title: "invoices_chefs_farm",
        };
      case "growy":
        return {
          companyFilter: GROWY,
          title: "invoices_growy",
        };
      default:
        return {
          companyFilter: "All",
          title: "all_invoices",
        };
    }
  };

  const config = getCompanyConfig(companyType);

  return <Invoices {...config} />;
};

export default InvoicesWrapper;
